<template>
	<div class="avue-logo">
		<transition name="fade">
			<img
				v-if="keyCollapse"
				key="0"
				:src="`/img/${getLogoUrl[0]}.png`"
				alt=""
				class="avue-logo_fold"
				@click="goIndex" />
		</transition>
		<transition-group name="fade">
			<img
				v-if="!keyCollapse"
				key="1"
				:src="`/img/${getLogoUrl[1]}.png`"
				alt=""
				class="avue-logo_unfold"
				@click="goIndex" />
		</transition-group>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'Logo',
	data() {
		return {}
	},
	computed: {
		...mapGetters(['website', 'keyCollapse']),
		getLogoUrl() {
			return this.envConfig.isBxIe() ? ['logo_ieb_fold', 'logo_ieb_unfold'] : ['mb_logo_main_fold', 'mb_logo_main']
		},
	},
	created() {},
	methods: {
		goIndex: function () {
			window.location.href = '/'
		},
	},
}
</script>

<style lang="scss">
.fade-leave-active {
	transition: opacity 0.2s;
}

.fade-enter-active {
	transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.avue-logo {
	position: fixed;
	top: 0;
	left: 0;
	width: 170px;
	height: 64px;
	line-height: 64px;
	background-color: #20222a;
	font-size: 20px;
	overflow: hidden;
	box-sizing: border-box;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
	color: rgba(255, 255, 255, 0.8);
	z-index: 1024;

	&_title {
		display: block;
		text-align: center;
		font-weight: 300;
		font-size: 16px;
	}

	&_subtitle {
		display: block;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
		color: #fff;
	}

	&_unfold {
		width: 170px;
		height: 64px;
	}

	&_fold {
		width: 60px;
		height: 64px;
	}
}
</style>
